export default "__VITE_ASSET__d4eab63d__"